<template>
    
    <div class="orderbottom">
    <div class="top">
        <div class="topin">
          <i class="el-icon-s-grid">我的订单</i>
        </div>
    </div>
    <div class="tab">
      <ordertable></ordertable>
    </div>
    </div>
</template>

<script>
import orderinfoVue from '../../../../components/Info/order/OrderInfo.vue';
import Ordertable from '../../../../components/Info/order/OrderTabel.vue'
  export default {
    components:{orderinfoVue,Ordertable},  
  }
</script>

<style>
.table{
    margin-top: 10px;
    padding-top: 30px;
    padding-left: 100px;
    padding-right: 100px;
    padding-bottom: 20px;
}
.el-table__header tr,
.el-table__header th {
height: 45px;
line-height: 45px;
}
.top{
    height: 40px;
    line-height: 40px;
    text-align: left;
  background-color:white;
}
.topin{
  background-color: rgb(251,251,251);
  margin-top: 20px;
  padding-left: 20px;
  height: 50px;
  line-height: 50px;
  color: rgb(90,165,240);
}
.orderbottom{
  background-color:white;
  margin-top: 40px;
  margin-right: 140px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.el-icon-s-grid{
  font-size: 20px;
  padding-left: 5px;
}
.tab{
  padding-left: 20px;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 10px;
}
</style>
